import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { MohAgreementHolder } from '@principle-theorem/principle-core';
import {
  IMohAgreementHolder,
  IPractice,
  IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

export type MohAgreementHolderProvider = WithRef<IStaffer> | WithRef<IPractice>;

export interface IMohAgreementHolderForm {
  provider: MohAgreementHolderProvider;
  payeeNumber: string;
  agreementNumber: string;
}

export class MohAgreementHolderForm {
  static init(): TypedFormGroup<IMohAgreementHolderForm> {
    return new TypedFormGroup<IMohAgreementHolderForm>({
      provider: new TypedFormControl<MohAgreementHolderProvider>(
        undefined,
        Validators.required
      ),
      payeeNumber: new TypedFormControl<string>('', Validators.required),
      agreementNumber: new TypedFormControl<string>('', Validators.required),
    });
  }

  static toAgreementHolder(
    formData: IMohAgreementHolderForm,
    practice: WithRef<IPractice>
  ): IMohAgreementHolder {
    return {
      ...MohAgreementHolder.fromProvider(formData.provider, practice),
      payeeNumber: formData.payeeNumber,
      agreementNumber: formData.agreementNumber,
    };
  }
}
